import {getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';

function findModal(modals: any, modalId: string) {
    const modal = modals.find((m: any) => m.id === modalId);
    return modal || {};
}

@Module({
    namespaced: true,
    name: 'ui',
    store,
    dynamic: true,
})
class UIModule extends VuexModule {
    public modals: object[] = [];

    get isModalVisible(): any {
        // un getter può tornare una funzione se abbiamo bisogno di passare dei parametri
        return (modalId: string) => {
            const modal = this.findModal(modalId);
            return modal ? modal.visible : false;
        };
    }

    get findModal(): any {
        return (modalId: string) => {
            return findModal(this.modals, modalId);
        };
    }

    @Mutation
    public newModal(modalId: string) {
        this.modals.push({id: modalId, visible: false});
    }

    @Mutation
    public openModal(modalId: string) {
        const modal = findModal(this.modals, modalId);
        modal.visible = true;
    }

    @Mutation
    public closeModal(modalId: string) {
        const modal = findModal(this.modals, modalId);
        modal.visible = false;
    }
}

export default getModule(UIModule);
